import { GridFilterModel, GridPaginationModel, GridSortModel } from "@mui/x-data-grid-premium";
import { createSlice } from "@reduxjs/toolkit";
import VwHastaUyarilisteDTO from "src/models/HastaUyariModels/VwHastaUyarilisteDTO";
import MapReducerPayloads from "src/models/store/MapReducerPayloads";
import { ApiResponse } from "src/services/core";

interface IHastaUyariListesi {
    open: boolean;
    data: HastaUyariListeListesiState;
    ekleOpen: boolean;
    activeRow: VwHastaUyarilisteDTO;
    paginationModel: GridPaginationModel;
    sortModel: GridSortModel;
    filterModel: GridFilterModel;

    uyariPopupOpen?: boolean;
};

export type HastaUyariListeListesiState = ApiResponse<Array<VwHastaUyarilisteDTO>> & {
    isFetching?: boolean;
    isLoading?: boolean;
};

export const HastaKaraListeSlice = createSlice<IHastaUyariListesi, MapReducerPayloads<IHastaUyariListesi, {
    setOpen: boolean;
    setData: HastaUyariListeListesiState;
    setEkleOpen: boolean;
    setActiveRow: VwHastaUyarilisteDTO;
    setPaginationModel: GridPaginationModel;
    setSortModel: GridSortModel;
    setFilterModel: GridFilterModel;

    setUyariPopupOpen: boolean;
}>>({
    name: "hastaKaraListe",
    initialState: {
        open: false,
        data: { data: [], isFetching: false, isLoading: true, },
        ekleOpen: false,
        activeRow: new VwHastaUyarilisteDTO(),
        paginationModel: { page: 0, pageSize: 100 },
        sortModel: [],
        filterModel: { items: [] },
        uyariPopupOpen: false,
    },
    reducers: {
        setOpen: (state, action) => {
            state.open = action.payload;
        },
        setData: (state, action) => {
            state.data = action.payload;
        },
        setEkleOpen: (state, action) => {
            state.ekleOpen = action.payload;
        },
        setActiveRow: (state, action) => {
            state.activeRow = action.payload;
        },
        setPaginationModel: (state, action) => {
            state.paginationModel = action.payload;
        },
        setSortModel: (state, action) => {
            state.sortModel = action.payload;
        },
        setFilterModel: (state, action) => {
            state.filterModel = action.payload;
        },
        setUyariPopupOpen: (state, action) => {
            state.uyariPopupOpen = action.payload;
        },
    },
});